// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Product, RecommendationsState } from "@coveo/headless/commerce";
import { getRealTimePricing, updatePreviousPurchaseDateForProduct, updateRealTimePricingForProducts } from "@DSG/Common/Utilities/CoveoUtilities";
import CoveoProductListProductContext from "@DSG/Components/Coveo/CoveoContext/CoveoProductListProductContext";
import CoveoProductCarouselProduct from "@DSG/Components/Coveo/RecommendationProduct/CoveoProductCarouselProduct";
import coveoRecommendation, { recommendationControllers } from "@DSG/Handlers/Coveo/CoveoRecommendation";
import colorPallete, { bodyFonts, elevation, headlineFonts, labelFonts, themeBreakPointValues } from "@DSG/MobiusOverrides/styles/variables";
import ProductCarouselProduct, {
  ProductCarouselProductStyles,
} from "@DSG/Overrides/Components/ProductCarouselProduct";
import { getSession, getSettingsCollection } from "@DSG/Overrides/Store/Context/ContextSelectors";
import { GetCoveoProducts } from "@DSG/Services/DsgCoveoProductsService";
import CoveoApplicationState from "@DSG/Store/Data/CoveoApplicationState/CoveoApplicationState";
import { DISPATCH_RECOMMENDATIONS_LIST_STATE } from "@DSG/Store/Reducer/CoveoCommerceReducer";
import { CoveoProductModel } from "@DSG/Type/CoveoModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import {
  getErrorMessage,
  getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import sendImpressionTracking from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendImpressionTracking";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentCartState, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import {
//     ProductCarouselProductStyles,
// } from "@insite/content-library/Components/ProductCarouselProduct";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
import useEmblaCarousel from "embla-carousel-react";
import React, { createRef, useCallback, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    displayForCoveoOnly = "displayForCoveoOnly",
    title = "title",
    carouselType = "carouselType",
    displayNameInTitle = "displayNameInTitle",
    carouselSlotId = "carouselSlotId",
    displayProductsFrom = "displayProductsFrom",
    selectedCategoryIds = "selectedCategoryIds",
    relatedProductType = "relatedProductType",
    numberOfProductsToDisplay = "numberOfProductsToDisplay",
    seedWithManuallyAssigned = "seedWithManuallyAssigned",
    maxNumberOfColumns = "maxNumberOfColumns",
    widgetPosition = "widgetPosition",
    showImage = "showImage",
    showTitle = "showTitle",
    showBrandName = "showBrandName",
    showPartNumbers = "showPartNumbers",
    showPrice = "showPrice",
    showAddToCart = "showAddToCart",
    showAddToList = "showAddToList",
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    visibleElementsTitle = "visibleElementsTitle",
    titleAlignment = "titleAlignment",
    customCSS = "customCSS",
    showViewProduct="showViewProduct",
    showQtyBox = "showQtyBox",
    fullWidthCarousel = "fullWidthCarousel",
    backgroundColor = "backgroundColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.displayForCoveoOnly]: boolean;
        [fields.title]: string;
        [fields.carouselType]: string;
        [fields.displayNameInTitle]: string;
        [fields.carouselSlotId]: string;
        [fields.displayProductsFrom]: string;
        [fields.selectedCategoryIds]: string[];
        [fields.relatedProductType]: string;
        [fields.numberOfProductsToDisplay]: number;
        [fields.seedWithManuallyAssigned]: string;
        [fields.maxNumberOfColumns]: number;
        [fields.widgetPosition]: number;
        [fields.showImage]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrandName]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToCart]: boolean;
        [fields.showAddToList]: boolean;
        [fields.showImageBadges]: boolean;
        [fields.maximumNumberOfImageBadges]: number;
        [fields.showTextBadges]: boolean;
        [fields.maximumNumberOfTextBadges]: number;
        [fields.visibleElementsTitle]: string;
        [fields.titleAlignment]: string;
        [fields.customCSS]: string;
        [fields.showViewProduct]: boolean;
        [fields.showQtyBox]: boolean;
        [fields.fullWidthCarousel]: boolean;
        [fields.backgroundColor]: string;
    };
}

const mapStateToProps = (state: CoveoApplicationState, ownProps: OwnProps) => ({
    products: getProductsForProductInfoList(state, ownProps.id),
    errorMessage: getErrorMessage(state, ownProps.id),
    pageType: getCurrentPage(state).type,
    productRecommendationWidgets: state.components.productRecommendations.widgets,
    session: state.context.session,
    brandFacets: getProductListDataViewProperty(state, "brandFacets"),
    selectedBrandIds: state.pages.productList.parameter?.brandIds,
    coveoCommerce: state.DSGGlobalData,
    settings: getSettingsCollection(state),
    isAuthenticated: getSession(state).isAuthenticated,
    cartState: getCurrentCartState(state),
    cartPageUrl: getPageLinkByPageType(state, "CartPage")?.url,
});

const mapDispatchToProps = {
    loadCarouselProducts,
    sendImpressionTracking,
    coveoRecommendation
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;

export interface ProductCarouselStyles {
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    arrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    carouselMainWrapper?: InjectableCss;
    carouselFullWidthWrapper?: InjectableCss;
}

export const productCarouselStyles: ProductCarouselStyles = {
    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-right: 24px;
                    `,
                ],
                "max",
            )}
        `
    },
    mainContainer: { 
        gap: 0,
        offsetCss: css`
          
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        position: relative;
                    `,
                ],
                "min",
            )}
        `
    },
    arrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
            position: absolute;
            max-width: 40px;
            flex-basis: 40px;
            display: flex;
            top: auto;
            bottom: 24px;
            &.rightArrowGrid {
                left: auto;
                right: calc(50% - 52px);
            }
            &.leftArrowGrid {
                left: calc(50% - 52px);
                right: auto;
            }

            button {
                border-radius: 50%;
                padding: 0;
                height: 40px;
                width: 40px;
                min-height: 40px;
                display: flex;
                align-items: center;
                background: ${colorPallete.white};
                border: 1px solid ${colorPallete.grey200};
                box-shadow: ${elevation.dp04};
                [class*="ButtonIcon-"] {
                    color: ${colorPallete.grey800};
                }
                &:disabled {
                    [class*="ButtonIcon-"] {
                        color: ${colorPallete.white};
                    }
                }
                &:not(:disabled) {
                    cursor: pointer;
                    border: 1px solid ${colorPallete.grey200};
                    background: ${colorPallete.white};
                    color: ${colorPallete.grey800};
                    [class*="ButtonIcon-"] {
                        color: ${colorPallete.grey800};
                    }
                    &:hover {
                        background: ${colorPallete.white};
                        color: ${colorPallete.black};
                        border: 1px solid ${colorPallete.grey100};
                
                        [class*="ButtonIcon-"] {
                            color: ${colorPallete.black};
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        bottom: 0;
                        top: 0;
                        &.rightArrowGrid {
                            left: auto;
                            right: 20px;
                        }
                        &.leftArrowGrid {
                            left: 20px;
                            right: auto;
                        }
                    `,
                ],
                "min",
            )}
        `,
    },
   
    carouselGridItem: {
        width: 12,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
          
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
            [data-test-selector="textBadges"] {
                margin-bottom: 8px !important;
                padding: 4px 0 0 4px;
            }
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            margin: 0 -8px;
            &.lessItemsThanSlideToScroll {
                justify-content: center;
                transform: initial !important;
            }
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;

          
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 0 20px;
            display: flex;
            flex-direction: column;
            @media only screen and (max-width: 767px) {
                padding-left: 0;
                padding-right: 0;
            }

            .addToCartContainer {
                margin-bottom: 0;
            }

           .uomMultiple {
                margin-top: 8px;
           }
        `,
    },
    carouselFullWidthWrapper: {
        css: css`
            width: 100%;
            margin: 0;
            padding: 24px 0 88px 24px;
            position: relative;
            .brandAndSubBrandWrapper {
                    [data-test-selector="subBrandSeparator"] {
                        top: 1px;
                        color: ${colorPallete.grey700};
                    }
                }
            .product-item-wrapper {
                [data-test-selector="textBadges"] {
                    margin: -4px 0 8px -12px;
                    padding: 0;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
            .priceLoadFailed {
                margin-bottom: 16px;
            }
            &.hasBadges {
                .product-item-wrapper {
                    min-height: 170px;
                    max-height: 170px;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    padding-top: 32px;
                }
            }
            .product-image-wrapper {
                display: flex;
                justify-content: center;
                img {
                    max-height: 138px;
                    margin: auto;
                    width: auto;
                    max-width: 100%;
                }
                > a {
                    height: 138px;
                }
            }
            .signInWrapperPrice {
                margin-top: auto;
                margin-bottom: 0;
                [data-test-selector="productPrice_PricingMessageSignIn"] {
                    margin-bottom: 0;
                }
            }
        
            [data-test-selector="slides"] > div {
                padding: 0 8px;
                margin: 0;
                > div {
                    background: ${colorPallete.white};
                }
            }
            [data-test-selector="carousel_slide"] {
                padding: 8px 16px 16px;
            }
        
            .product-item-wrapper {
                border: none;
                padding: 0;
                display: flex;
                flex-direction: column;
                min-height: 138px;
                max-height: 138px;
            }
            
            .product-description-wrapper {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
            [data-test-selector="addToCartBtn"] {
                min-height: 38px;
                padding: 9px 24px
            }
            .carouselProduct {
                flex-basis: 100%;
                max-width: 100%;
            }
            .productBrandNameWrapper {
                margin: 8px 0 4px;
                &, span {
                    font: ${labelFonts.label1Regular.fontWeight} ${labelFonts.label1Regular.fontSize}/${labelFonts.label1Regular.lineHeight} ${labelFonts.label1Regular.fontFamily};
                    color: ${colorPallete.grey600};
                }
            }
            [data-test-selector="productDescriptionLink"] {
                font: ${bodyFonts.body2SemiBoldSm.fontWeight}  ${bodyFonts.body2SemiBoldSm.fontSize}/20px ${bodyFonts.body2SemiBoldSm.fontFamily};
                color: ${colorPallete.grey800};
                margin-bottom: 8px;  
                align-items: flex-start;
                > span {
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
            }
            [data-test-selector="priceIncludeVat"] {
                color: ${colorPallete.grey800};
            }
            [data-test-selector="productPrice_unitNetPrice"] {
                align-items: center;
                display: flex;
                color: ${colorPallete.grey800};
                .price {
                    font: ${headlineFonts.headline3SemiBoldSm.fontWeight} ${headlineFonts.headline3SemiBoldSm.fontSize}/${headlineFonts.headline3SemiBoldSm.lineHeight} ${headlineFonts.headline3SemiBoldSm.fontFamily};
                }
                .uom {
                    font: ${bodyFonts.body2RegularSm.fontWeight}  ${bodyFonts.body2RegularSm.fontSize}/${bodyFonts.body2RegularSm.lineHeight} ${bodyFonts.body2RegularSm.fontFamily};
                }
            }
            
            
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    padding-bottom: 24px;
                    [data-test-selector="productPrice_unitNetPrice"] {
                        .price {
                            font-size: ${headlineFonts.headline2SemiBoldLg.fontSize}; 
                            line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight}; 
                        }
                    }
                    [data-test-selector="addToCartBtn"] {
                        min-height: 48px;
                        padding: 14px 32px;
                    }
                    [data-test-selector="productPrice_unitNetPrice"] {
                        .uom {
                            font-size: ${bodyFonts.body2RegularLg.fontSize};
                            line-height: ${bodyFonts.body2RegularLg.lineHeight};
                        }
                    }
                    
                `,
            ],
            "min",
            )}
        
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    width: 100%;
                    margin: 0;
                    padding: 24px 0;
                
                    .view-product-btn  {
                        .btn {
                            margin-top: 5px;
                        }
                    }
                    .carouselProduct {
                        padding: 0;
                        flex-basis: calc(100% - 160px);
                        max-width: calc(100% - 160px);
                        &[class*="GridItem"] {
                            margin: auto;
                        }
                    }
                  
                  
                `,
                css`
                    margin-top: 24px !important;  
                    &.product-carousel {
                        width: calc(100% + 48px);
                        margin: 0 -24px;
                    }
                    .carouselProduct {
                        flex-basis: calc(100% - 260px);
                        max-width: calc(100% - 260px);
                    }
                `,
            ],
            "min",
            )}
           
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        &.product-carousel {
                            width: calc(100% + 32px);
                            margin: 0 -16px;
                        }
                    `
                ],
                "max",
            )}
            @media print {
                &.product-carousel {
                    [data-test-selector="productDescriptionLink"] {
                        height: 65px;
                    }
                    .product-image-wrapper {
                        width: 100%;
                        max-width: 75%;
                        text-align: center;
                        margin: auto;
                    }
                    [data-test-selector="carousel_slide"] {
                        padding-bottom: 0;
                    }
            
                    padding: 0;
                    .arrowsGrid {
                        display: none;
                    }
                    [data-test-selector="productPrice_unitNetPrice"] {
                        font-size: 20px;
                    }
                    .view-product-btn .btn {
                        display: none;
                    }
                    .carouselProduct {
                        flex-basis: 100%;
                        max-width: 100%;
                        width: 100%;
                        padding: 0;
                        [data-test-selector="slides"] {
                            display: block;
                            transform: initial !important;
                            > div {
                                width: 30% !important;
                                vertical-align: top;
                                display: inline-block;
                                left: 0 !important;
                                max-width: 30%;
                                min-width: 30%;
                            }
                        }
                    }
                }
            }
            @media screen and (max-width: 520px) {
                [data-test-selector="slides"] {
                    > div {
                        max-width: 237px !important;
                        min-width: 237px;
                    }
                }
            }
    
        `
    },
    carouselMainWrapper: {
        css: css`
            .brandsOuterWrapper {
                min-height: 18px;
            }
            .brandAndSubBrandWrapper {
                [data-test-selector="subBrandSeparator"] {
                    top: -1px;
                    color: ${colorPallete.grey700};
                }
            }
            [data-test-selector="subBrandSeparator"],
            [data-test-selector="brandLink"] span,
            [data-test-selector="brandName"] {
                font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                color: ${colorPallete.grey600};
            }   
            [data-test-selector="productDescriptionLink"] {
                font: ${labelFonts.label1SemiBold.fontWeight} ${labelFonts.label1SemiBold.fontSize}/${labelFonts.label1SemiBold.lineHeight} ${labelFonts.label1SemiBold.fontFamily};
                display: -webkit-box;
                overflow: hidden;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            [data-test-selector="productImage"],
            [data-test-selector="coveoProductImage"] {
                justify-content: center;
                img {
                    max-height: 138px;
                    width: auto;
                }
            }
            .headlineText {
                
                font-size: ${headlineFonts.headline4SemiBoldSm.fontSize};
                line-height: ${headlineFonts.headline4SemiBoldSm.lineHeight};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        &.notBadges,
                        &.hasBadges {
                            .product-item-wrapper {
                                max-height: 170px;
                                min-height: 170px;
                            }
                            .product-image-wrapper {
                                min-height: 170px;
                                max-height: 170px;
                                display: flex;
                                justify-content: space-between;
                                flex-direction: column;
                            }
                        }
                        &.withArrowCarousel {
                            padding-bottom: 24px;
                            margin-bottom: 56px;
                            border-bottom: 1px solid ${colorPallete.grey300};
                        }
                        [data-test-selector="carousel_slide"] {
                            padding: 0 12px;
                        }
                        [data-test-selector="productCarouselBadge"] {
                            padding-top: 0;
                        }
                        [data-test-selector="slides"] {
                            margin: 0 -12px;
                        }
                        .headingText {
                            margin-bottom: 16px;
                        }
                        .arrowsGrid {
                            bottom: -80px;
                            top: auto;
                            &.leftArrowGrid {
                                left: calc(50% - 52px);
                                right: auto;
                            }
                            
                            &.rightArrowGrid {
                                left: auto;
                                right: calc(50% - 52px);
                            }
                        }
                    `
                ],
                "min",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 0 0 0 16px;
                        [data-test-selector="slides"] {
                            margin: 0;
                            gap: 16px;
                            > div:last-child {
                                margin-right: 16px;
                            }
                            > div {
                                max-width: calc(100% - 174px) !important;
                            }
                        }
                        .arrowsGrid {
                            display: none;
                        }
                        &.hasBadges {
                           [data-test-selector="carousel_slide"] {
                                padding-top: 40px;
                                [data-test-selector="textBadges"] {
                                    position: absolute;
                                    left: -4px;
                                    top: -36px;
                                    flex-wrap: nowrap;
                                }
                           }
                        }
                        [data-test-selector="carousel_slide"] {
                            display: flex;
                            padding: 8px;
                            gap: 8px;
                            border-radius: 8px;
                            border: 1px solid ${colorPallete.grey300};
                            background: ${colorPallete.white};
                            flex-direction: row;
                            
                            > div:empty {
                                display: none;
                            }
                            [data-test-selector="productImage"],
                            [data-test-selector="coveoProductImage"] {
                                min-width: 80px;
                            }
                        }
                        [data-test-selector="productImage"],
                        [data-test-selector="coveoProductImage"] {
                            img {
                                max-height: 80px;
                                width: auto;
                            }
                        }
                        .productBrandNameWrapper {
                            margin: 0 0 4px;
                            min-height: initial;
                            display: flex;
                        }
                        .headingText {
                            margin-bottom: 8px;
                        }
                        .product-item-wrapper {
                            display: flex;
                            flex-direction: column;
                            > div {
                                display: flex;
                            }
                        }
                    `
                ],
                "max",
            )}
        `
    }
};

const defaultCustomCss = `.wrapper {
}

.titleText {
}
`;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const styles = productCarouselStyles;

const ProductCarousel = ({
    id,
    theme,
    fields,
    products,
    errorMessage,
    loadCarouselProducts,
    pageType,
    shellContext,
    productRecommendationWidgets,
    sendImpressionTracking,
    session,
    brandFacets,
    selectedBrandIds,
    settings, 
    coveoRecommendation,
    coveoCommerce,
    isAuthenticated,
    cartState,
    cartPageUrl,
}: Props) => {
    const afterCarousel = createRef<HTMLSpanElement>();
    const isProductDetailsPage = pageType === "ProductDetailsPage";
    const isProductListPage = pageType === "ProductListPage";
    const isBrandDetailsPage = pageType === "BrandDetailsPage";
    const brand = useContext(BrandStateContext).value;
    const category = useContext(CategoryContext);
    const productContext = useContext(ProductContext);

    const allSettings = settings as any;
    const isCoveoEnabled = allSettings.customSettings.enableCoveoSearch && fields.displayForCoveoOnly;
    const catalogSettings = allSettings.catalogUrlSettings;
    const catalogleneralsettings = allSettings.catalogGeneralSettings;

    const [coveoProducts, setCoveoProducts] = useState<CoveoProductModel[]>([]);
    const [coveoProductsNumber, setCoveoProductsNumber] = useState<any[]>([]);
    const [productIdUpdated, setProductIdUpdated] = useState<boolean>();
    const [loadingRealtimePrice, setLoadingRealtimePrice] = useState<boolean>();

    const dispatch = useDispatch();
    let isCartPage = false;
    if (typeof window !== 'undefined')
    {
        isCartPage = window.location.pathname === cartPageUrl;
    }
    
    useEffect(() => {
        if(isCoveoEnabled){
             
            if(isCartPage)
            {
                dispatch({
                    type: DISPATCH_RECOMMENDATIONS_LIST_STATE,
                    state: []
                });
                
                if(cartState.value !== undefined && !isCartEmpty(cartState.value)){
                    coveoRecommendation({slotId: fields.carouselSlotId,coveoCommerce,productNumber:undefined})
                }
            }
            else if(isProductDetailsPage){
                coveoRecommendation({slotId: fields.carouselSlotId,coveoCommerce,productNumber: productContext?.product?.productNumber})
             }
            else{
                coveoRecommendation({slotId: fields.carouselSlotId,coveoCommerce,productNumber:undefined})
            }
        }
        else {
            loadCarouselProducts({
                isShellEdit: shellContext.isInShell && shellContext.isEditing,
                carouselId: id,
                carouselType: fields.carouselType,
                relatedProductType: fields.relatedProductType,
                seedWithManuallyAssigned: fields.seedWithManuallyAssigned,
                displayProductsFrom: fields.displayProductsFrom,
                selectedCategoryIds: fields.selectedCategoryIds,
                numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
                widgetPosition: fields.widgetPosition,
                isProductDetailsPage,
                productId: productContext?.product?.id,
                isProductListPage,
                category,
                isBrandDetailsPage,
                brand,
            });
        }    
    }, [
        fields.carouselType,
        fields.relatedProductType,
        fields.seedWithManuallyAssigned,
        fields.displayProductsFrom,
        fields.selectedCategoryIds,
        fields.numberOfProductsToDisplay,
        fields.widgetPosition,
        productContext?.product?.id,
        category?.id,
        brand?.id,
        productRecommendationWidgets,
        session?.pickUpWarehouse?.id,
        cartState,
    ]);

    useEffect(() => { 
        const recommendationState = coveoCommerce?.RecommendationsListState?.find((entry: { slotId: string; }) => entry.slotId === fields.carouselSlotId)?.recommendationState;
        const convertedProducts = convertProductArrToCoveoProductModelArr(recommendationState?.products || [],recommendationState)
        setCoveoProducts(convertedProducts);
        const productNumbers = convertedProducts.map(product => ({ productNumber: product.productNumber }));
        setCoveoProductsNumber(productNumbers);
    }, [coveoCommerce?.RecommendationsListState?.find((entry: { slotId: string; }) => entry.slotId === fields.carouselSlotId)?.recommendationState?.isLoading === false]);
    
    const convertProductArrToCoveoProductModelArr = (products: Product[], recommendationState: RecommendationsState | undefined): CoveoProductModel[] => {
        return products.map((_product) => {
            const product = _product;
            const responseId = recommendationState?.responseId || "";
            const productId = "";
            // const groupId: any = product.additionalFields?.ec_item_group_id;
            // Check if product already exists in the hold list
            
            // const variantTypeId = (groupId && !groupId.includes(productId)) ? productId : null;
            const recommendation = recommendationControllers[fields.carouselSlotId];
            const interactiveProduct = recommendation?.interactiveProduct({ options: { product } });
            return ({
                title: product.ec_name,
                brandName: product.ec_brand,
                categoryName: product.ec_category,
                subBrandName:product.additionalFields?.ec_brand_name_sub ?? "",
                shortDescription: product.ec_shortdesc,
                productNumber: product.ec_product_id,
                manufacturerItem: product.additionalFields?.ec_manufactureritem,
                availability: product.additionalFields?.ec_availability,
                urlSegment: `/${catalogSettings.productRootPath}/${product.ec_product_id}`,
                imageAltText: product.ec_name,
                mediumImagePath: product.additionalFields?.mediumimagepath,
                smallImagePath: ((product.additionalFields?.ec_smallimagepath && product.additionalFields?.ec_smallimagepath !== "") ? product.additionalFields?.ec_smallimagepath : catalogleneralsettings.notFoundSmallImagePath),
                // variantTypeId,
                canAddToCart: false,
                quoteRequired: product.additionalFields?.quoteRequired,
                minimumOrderQty: (product.additionalFields?.ec_minimumorderqty === "0" || product.additionalFields?.ec_minimumorderqty === null || product.additionalFields?.ec_minimumorderqty === undefined)  ? "1" : String(product.additionalFields?.ec_minimumorderqty),
                allowZeroPricing: false,
                unitListPrice: product.additionalFields?.ec_unit_list_price,
                vendorAuthRequiredList: product.additionalFields?.ec_vendor_auth_required_list,
                vendorAuthRequiredLink: product.additionalFields?.ec_vendor_auth_required_link,
                unitofmeasure: product.additionalFields?.ec_unitofmeasure,
                productId,
                canonicalUrl: product.clickUri,
                pricing: null,
                inventory: undefined,
                badges: undefined,
                upcCode: product.additionalFields?.ec_upc,
                classificatioN_CODE: product.additionalFields?.ec_classification_code,
                saleType: product.additionalFields?.ec_saletype,
                onSaleNow: product.additionalFields?.ec_onsalenow,
                brandUrlSegment: product.ec_brand ? `${catalogSettings.brandRootPath}/${buildBrandURLSegment(product.ec_brand)}` : '',
                isNewProduct: "",
                showAuthorizationRequired: false,
                responseId,
                position: product.position,
                customerProductNumber: product.additionalFields?.ec_customer_product_number,
                previousPurchaseDate: "",
                interactiveProduct,
                isdiscontinued:product.additionalFields?.ec_isdiscontinued??false
            }) as CoveoProductModel;
        }) || [];
    };

    const buildBrandURLSegment = (str:string) =>{
        if(!str){return str}

        return str
        .toLowerCase() 
        .replace(/\s+/g, '-') 
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-');
    };   
        
    useEffect(() => {
        if(coveoProductsNumber.length > 0){
            const fetchCoveoProductData = async () => {
                setProductIdUpdated(false)
                const coveoProductData= await GetCoveoProducts(coveoProductsNumber);
            
                if(coveoProductData !== undefined){
                    const productsWithPreviousDate = updatePreviousPurchaseDateForProduct(coveoProducts ,coveoProductData)
                    if (productsWithPreviousDate !== undefined) {
                        // if a product is already in the list, update it
                        const updatedProducts = coveoProducts.map((product) => {
                            const updatedProduct = productsWithPreviousDate.find((p) => p.productNumber === product.productNumber);
                            return updatedProduct || product;
                        });
                        // console.log("AddRealTimePricesToProducts >> updatedProducts", updatedProducts);
                        setCoveoProducts(updatedProducts);
                        setProductIdUpdated(true)
                        setLoadingRealtimePrice(false);
                    }
                }
            }
            fetchCoveoProductData();
        }
    }, [coveoProductsNumber]);

    useEffect(() => {
            if (isAuthenticated && coveoProducts.length > 0) {
                AddRealTimePricesToProducts(coveoProducts);
            }
    }, [productIdUpdated]);
    
    const AddRealTimePricesToProducts = async (products: CoveoProductModel[]) => {
          // console.log("AddRealTimePricesToProducts >>", products);
          if (products.length === 0 || productIdUpdated === undefined || !productIdUpdated) { return; }
          if (isAuthenticated && (loadingRealtimePrice === undefined || !loadingRealtimePrice)) {
              
          const productPricing: any = await getRealTimePricing(products);
          if (productPricing === null || productPricing === undefined) {
              setLoadingRealtimePrice(false);
              return;
          }
          const productsWithPrice = updateRealTimePricingForProducts(
              products,
              productPricing?.realTimePricingResults as ProductPriceDto[],
          );

          // console.log("AddRealTimePricesToProducts >> productsWithPrice", productsWithPrice);
          if (productsWithPrice !== undefined) {
              // if a product is already in the list, update it
              const updatedProducts = coveoProducts.map((product) => {
                  const updatedProduct = productsWithPrice.find((p) => p.productId === product.productId);
                  return updatedProduct || product;
              });
              // console.log("AddRealTimePricesToProducts >> updatedProducts", updatedProducts);
              setCoveoProducts(updatedProducts);
              setLoadingRealtimePrice(true);
          }
          // setLoadingRealtimePrice(false);    
        }
    };


    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        const maxNumberOfColumns = fields.maxNumberOfColumns || 5;

        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        const { innerWidth } = window;
        if (innerWidth <= 520) {
            localSlidesToScroll = 1;
        } else if (innerWidth < themeBreakPointValues.mobileLarge) {
            localSlidesToScroll = 2;
            if(fields.fullWidthCarousel) {
                localSlidesToScroll = 2;
            } else {
                localSlidesToScroll = 1;
            }
        } else if (innerWidth < themeBreakPointValues.tabletLarge) {
            if(fields.fullWidthCarousel) {
                localSlidesToScroll = 3;
            } else {
                localSlidesToScroll = 2;
            }
        } else if (innerWidth < themeBreakPointValues.laptopSmall) {
            localSlidesToScroll = 4;
        } else {
            localSlidesToScroll = maxNumberOfColumns;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [fields.maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(0);

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);
    }, [fields.maxNumberOfColumns, windowResizeTime]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);

    useEffect(() => {
        if(!isCoveoEnabled){
            if (!embla || !products || products.length === 0) {
                return;
            }
            embla.reInit({
                align: "start",
                slidesToScroll,
                watchDrag: isTouchDevice(),
                loop: products.length > slidesToScroll,
            });
            setCanScroll();
        }
    }, [embla, slidesToScroll, products]);

    useEffect(() => {
        if(isCoveoEnabled){
            if (!embla || !coveoProducts || coveoProducts.length === 0) {
                return;
            }
             embla.reInit({
                align: "start",
                slidesToScroll,
                watchDrag: isTouchDevice(),
                loop: coveoProducts.length > slidesToScroll,
            });
            setCanScroll();
        }
    }, [embla, slidesToScroll, coveoProducts]);

    useEffect(() => {
        if (
            // fields.carouselType !== "recommendedProducts" ||
            !productRecommendationWidgets ||
            fields.widgetPosition > productRecommendationWidgets.length ||
            !products
        ) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        const recommendationIds: number[] = [];
        products?.forEach(o => {
            const id = productRecommendationWidget.recs.find(r => r.refCode === o.detail?.name)?.id;
            if (id) {
                recommendationIds.push(id);
            }
        });

        if (recommendationIds.length) {
            sendImpressionTracking({ recommendationIds });
        }
    }, [fields.carouselType, productRecommendationWidgets, products]);

    const getProductRecommendationId = (product: ProductModel) => {
        if (!productRecommendationWidgets || fields.widgetPosition > productRecommendationWidgets.length) {
            return;
        }

        const productRecommendationWidget = productRecommendationWidgets[fields.widgetPosition - 1];
        return productRecommendationWidget.recs.find(r => r.refCode === product.detail?.name)?.id;
    };

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (!isCoveoEnabled && (!products || products.length === 0)) {
        return null;
    }
    if(isCoveoEnabled && (!coveoProducts || coveoProducts.length === 0)){
        return null;
    }

    const title =
        fields.title ||
        translate(carouselTypeOptions.find(o => o.value === fields.carouselType)?.displayName || "Product Carousel");
    let showBrandBlocks = fields.showBrandName;
    if(isCoveoEnabled) {
     showBrandBlocks = fields.showBrandName && coveoProducts.some(o => !!o.brandName);
    }
    else if(products) {
      showBrandBlocks = fields.showBrandName && products.some(o => !!o.brand);
    }
   
    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };

    const iscarouseltyperecommendedProducts = fields.carouselType === "recommendedProducts" && category != null;
   
    const isBrandCarouselTypeProducts = fields.carouselType === "recommendedProducts" && isBrandDetailsPage && brand !=null;
   
    const carouselMainWrapperStyles = fields.fullWidthCarousel ? styles.carouselFullWidthWrapper : styles.carouselMainWrapper;
   
    const displayArrow = (products && products.length > slidesToScroll) || (coveoProducts && coveoProducts.length > slidesToScroll);

    let checkBadgeExitsClass = "notBadges";
    let checkBadgeExits = false;
    checkBadgeExits = (products?.some((p) => (p.badges ?? []).length > 0) ?? false) || (coveoProducts?.some((p) => (p.badges ?? []).length > 0) ?? false);
    
    if(checkBadgeExits) {
        checkBadgeExitsClass = 'hasBadges';
    } 
   
    return (
        <StyledWrapper {...customCssWrapper} {...carouselMainWrapperStyles} 
            style={
                fields.fullWidthCarousel ?
                { 
                    boxShadow: `-50em 0 0 ${fields.backgroundColor}, 50em 0 0 ${fields.backgroundColor}`,
                    background: fields.backgroundColor ?? fields.backgroundColor
                } : {}
            }
            className={`product-carousel ${checkBadgeExitsClass} ${displayArrow ? 'withArrowCarousel' : ''} ${fields.fullWidthCarousel ? 'product-expanded-grid-carousel' : ''}`}>
            <>
                <SkipNav
                    text={translate("Skip Carousel")}
                    extendedStyles={styles.skipCarouselButton}
                    destination={afterCarousel}
                />

                {(iscarouseltyperecommendedProducts && fields.displayNameInTitle) ? (
                    <ContentWrapper alignment={fields.titleAlignment} className="wrapper">
                        <Typography {...styles.titleText} className="headingText" data-test-selector={`${fields.carouselType}__title`}>
                            {title} {translate("in")} {category?.name}
                        </Typography>
                    </ContentWrapper>
                ) : ((isBrandCarouselTypeProducts && fields.displayNameInTitle) ? (
                    <ContentWrapper alignment={fields.titleAlignment} className="wrapper">
                        <Typography {...styles.titleText} className="headingText" data-test-selector={`${fields.carouselType}__title`}>
                            {brand?.name} {title}
                        </Typography>
                    </ContentWrapper>
                ): (
                    <ContentWrapper alignment={fields.titleAlignment} className="wrapper">
                        <Typography {...styles.titleText} className="headingText">{title}</Typography>
                    </ContentWrapper>
                ))}

                <GridContainer
                    {...styles.mainContainer}
                    className="productCarouselContainer"
                    data-test-selector={`productCarousel_${fields.carouselType}${fields.relatedProductType}`}
                >
                    <GridItem
                        {...styles.carouselGridItem} className="carouselProduct"
                        data-test-selector={`carouselGridItem_${fields.carouselType}${fields.relatedProductType}`}
                    >
                        <StyledWrapper {...styles.carouselWrapper}>
                            <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                                <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides"
                                    className={` ${
                                       products? (products?.length >= slidesToScroll
                                            ? "moreItemsThanSlideToScroll"
                                            : "lessItemsThanSlideToScroll"):coveoProducts.length >= slidesToScroll
                                            ? "moreItemsThanSlideToScroll"
                                            : "lessItemsThanSlideToScroll"
                                    }`}
                                    >
                                    {!isCoveoEnabled && products?.map(product => (
                                        <StyledWrapper
                                            {...styles.carouselSlide}
                                            className={`carouselSlide__${fields.carouselType}`}
                                            key={product.id}
                                            style={{ maxWidth: `calc(100% / ${slidesToScroll})`, flexBasis: `calc(100% / ${slidesToScroll})`, width: `calc(100% / ${slidesToScroll})` }}
                                        >
                                            <StyledWrapper
                                                {...styles.carouselSlideInner}
                                                id={`product_${product.id}`}
                                                data-test-key={product.id}
                                                data-test-selector="carousel_slide"
                                                className={`${fields.carouselType}__product`}
                                            >
                                                <ProductCarouselProduct
                                                    carouselId={id}
                                                    carouselType={fields.carouselType}
                                                    product={product}
                                                    recommendationId={getProductRecommendationId(product)}
                                                    showImage={fields.showImage}
                                                    showBrand={showBrandBlocks}
                                                    showTitle={fields.showTitle}
                                                    showPartNumbers={fields.showPartNumbers}
                                                    showPrice={fields.showPrice}
                                                    showAddToCart={fields.showAddToCart}
                                                    showAddToList={fields.showAddToList}
                                                    showImageBadges={fields.showImageBadges}
                                                    maximumNumberOfImageBadges={fields.maximumNumberOfImageBadges}
                                                    showTextBadges={fields.showTextBadges}
                                                    maximumNumberOfTextBadges={fields.maximumNumberOfTextBadges}
                                                    extendedStyles={styles.carouselProductStyles}
                                                    showViewProduct={fields.showViewProduct}
                                                    showQtyBox={fields.showQtyBox}
                                                />
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    ))}
                                    {isCoveoEnabled && coveoProducts.map(product => (
                                        <CoveoProductListProductContext coveoProduct={product} key={`ListView-${product.productNumber}`}>
                                                <StyledWrapper
                                                    {...styles.carouselSlide}
                                                    className={`carouselSlide__${fields.carouselType}`}
                                                    key={product.productNumber}
                                                    style={{ maxWidth: `calc(100% / ${slidesToScroll})`, flexBasis: `calc(100% / ${slidesToScroll})`, width: `calc(100% / ${slidesToScroll})` }}
                                                >
                                                    <StyledWrapper
                                                        {...styles.carouselSlideInner}
                                                        id={`product_${product.productNumber}`}
                                                        data-test-key={product.productNumber}
                                                        data-test-selector="carousel_slide"
                                                        className={`${fields.carouselType}__product`}
                                                    >
                                                        <CoveoProductCarouselProduct
                                                            carouselId={id}
                                                            carouselType={fields.carouselType}
                                                            product={product}
                                                            recommendationId={undefined}
                                                            showImage={fields.showImage}
                                                            showBrand={showBrandBlocks}
                                                            showTitle={fields.showTitle}
                                                            showPartNumbers={fields.showPartNumbers}
                                                            showPrice={fields.showPrice}
                                                            showAddToCart={fields.showAddToCart}
                                                            showAddToList={fields.showAddToList}
                                                            showImageBadges={fields.showImageBadges}
                                                            maximumNumberOfImageBadges={fields.maximumNumberOfImageBadges}
                                                            showTextBadges={fields.showTextBadges}
                                                            maximumNumberOfTextBadges={fields.maximumNumberOfTextBadges}
                                                            extendedStyles={styles.carouselProductStyles}
                                                            showViewProduct={fields.showViewProduct}
                                                            showQtyBox={fields.showQtyBox}
                                                        />
                                            </StyledWrapper>
                                        </StyledWrapper>
                                        </CoveoProductListProductContext>
                                        
                                    ))}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.arrowGridItem} className="arrowsGrid leftArrowGrid">
                        {displayArrow && (
                            <Button
                                {...styles.prevArrowButton}
                                onClick={() => embla && embla.scrollPrev()}
                                disabled={!canScrollPrev}
                                data-test-selector="prevBtn"
                                aria-label={translate('Previous Arrow')}
                            >
                                <ButtonIcon src={ChevronLeft} />
                            </Button>
                        )}
                    </GridItem>
                    <GridItem {...styles.arrowGridItem} className="arrowsGrid rightArrowGrid">
                        {displayArrow && (
                            <Button
                                {...styles.nextArrowButton}
                                onClick={() => embla && embla.scrollNext()}
                                disabled={!canScrollNext}
                                data-test-selector="nextBtn"
                                aria-label={translate('Next Arrow')}
                            >
                                <ButtonIcon src={ChevronRight} />
                            </Button>
                        )}
                     
                    </GridItem>
                </GridContainer>
                <span ref={afterCarousel} tabIndex={-1} />
            </>
        </StyledWrapper>
    );
};

const carouselTypeOptions = [
    { value: "crossSells", displayName: "Cross Sells" },
    { value: "customersAlsoPurchased", displayName: "Customers Also Purchased" },
    { value: "recentlyViewed", displayName: "Recently Viewed" },
    { value: "relatedProducts", displayName: "Related Products" },
    { value: "topSellers", displayName: "Top Sellers" },
    { value: "recommendedProducts", displayName: "Recommended Products" },
];

export const ContentWrapper = styled.div<InjectableCss & { alignment: string }>`
    display: flex;
    width: 100%;
    justify-content: ${props => props.alignment ?? "flex-start"};
    text-align: ${props => {
        switch (props.alignment) {
          case 'center':
            return 'center';
          case 'flex-end':
            return 'right';
          case 'flex-start':
          default:
            return 'left';
        }
      }};
      
    ${injectCss};
`;

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(ProductCarousel))),
    definition: {
        group: "Common",
        icon: "gallery-thumbnails",
        fieldDefinitions: [
            {
                name: fields.displayForCoveoOnly,
                displayName: "Display For Coveo Only",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                sortOrder: 0,
                tab: basicTab
            },
            {
                name: fields.carouselSlotId,
                displayName: "Carousel Slot ID",
                editorTemplate: "TextField",
                defaultValue: "621c71e9-aa21-4a9a-a037-30bffd6f986a",
                fieldType: "Contextual",
                sortOrder: 0,
                tab: basicTab,
            },
            {
                name: fields.fullWidthCarousel,
                displayName: "Full Width Carousel",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 0,
            },
            {
                name: fields.backgroundColor,
                displayName: "Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "#F6F6F7",
                fieldType: "General",
                sortOrder: 0,
                isVisible: widget => widget.fields.fullWidthCarousel,
            },
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 0,
                tab: basicTab,
            },
            {
                name: fields.titleAlignment,
                displayName: "Title Alignment",
                editorTemplate: "RadioButtonsField",
                defaultValue: "center",
                horizontal: true,
                fieldType: "General",
                sortOrder: 1,
                tab: basicTab,
                options: [
                    {
                        displayName: "Left",
                        value: "flex-start",
                    },
                    {
                        displayName: "Center",
                        value: "center",
                    },
                    {
                        displayName: "Right",
                        value: "flex-end",
                    },
                ],
            },
           
            {
                name: fields.carouselType,
                displayName: "Carousel Type",
                editorTemplate: "DropDownField",
                options: carouselTypeOptions,
                defaultValue: "crossSells",
                fieldType: "Contextual",
                sortOrder: 2,
                tab: basicTab,
                customFilter: (item, pageType, settings) => {
                    const {
                        settingsCollection: {
                            websiteSettings: { enableDynamicRecommendations },
                            productSettings: { enableProductRecommendations },
                        },
                    } = settings;

                    if (!enableDynamicRecommendations && item.value === "topSellers") {
                        return false;
                    }

                    if (!enableProductRecommendations && item.value === "recommendedProducts") {
                        return false;
                    }

                    if (
                        (pageType.type !== "ProductDetailsPage" && item.value === "relatedProducts") ||
                        (pageType.type !== "ProductDetailsPage" &&
                            pageType.type !== "CartPage" &&
                            item.value === "customersAlsoPurchased")
                    ) {
                        return false;
                    }

                    return true;
                },
            },
            {
                name: fields.displayNameInTitle,
                displayName: "Display Name In Title for Recommedation",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "recommendedProducts",
                sortOrder: 5,
                tab: basicTab,
            },
            {
                name: fields.displayProductsFrom,
                displayName: "Display Products From",
                editorTemplate: "DropDownField",
                options: [
                    { value: "allCategories", displayName: "All Categories" },
                    { value: "selectedCategories", displayName: "Selected Categories" },
                    { value: "customerSegments", displayName: "Customer Segments" },
                ],
                defaultValue: "allCategories",
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "topSellers",
                sortOrder: 3,
                tab: basicTab,
            },
            {
                name: fields.selectedCategoryIds,
                displayName: "Selected Categories",
                editorTemplate: "CategoriesField",
                defaultValue: [],
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "topSellers" &&
                    item.fields[fields.displayProductsFrom] === "selectedCategories",
                sortOrder: 4,
                tab: basicTab,
            },
            {
                name: fields.relatedProductType,
                displayName: "Related Product Type",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductRelationship",
                defaultValue: "",
                fieldType: "Contextual",
                isVisible: item => item.fields[fields.carouselType] === "relatedProducts",
                sortOrder: 5,
                tab: basicTab,
            },
            {
                name: fields.numberOfProductsToDisplay,
                displayName: "Number Of Products To Display",
                editorTemplate: "IntegerField",
                min: 1,
                max: 20,
                defaultValue: 10,
                fieldType: "Contextual",
                isVisible: item =>
                    item.fields[fields.carouselType] === "customersAlsoPurchased" ||
                    item.fields[fields.carouselType] === "topSellers",
                sortOrder: 6,
                tab: basicTab,
            },
            {
                name: fields.seedWithManuallyAssigned,
                displayName: "Seed With Manually Assigned",
                editorTemplate: "SystemListDropDownField",
                systemListName: "ProductRelationship",
                defaultValue: "",
                fieldType: "Contextual",
                isVisible: (item, _advancedFeaturesEnabled, _theme, pageType) =>
                    pageType === "ProductDetailsPage" && item.fields[fields.carouselType] === "customersAlsoPurchased",
                sortOrder: 7,
                tab: basicTab,
            },
            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 5,
                defaultValue: 4,
                fieldType: "Contextual",
                sortOrder: 8,
                tab: basicTab,
            },
            {
                name: fields.widgetPosition,
                displayName: "Widget Position",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 1,
                fieldType: "Contextual",
                // isVisible: item => item.fields[fields.carouselType] === "recommendedProducts",
                sortOrder: 9,
                tab: basicTab,
            },
            {
                name: fields.visibleElementsTitle,
                displayName: "Visible Elements",
                editorTemplate: "LabelField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 10,
                tab: basicTab,
            },
            {
                name: fields.showImage,
                displayName: "Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "Contextual",
                sortOrder: 11,
                tab: basicTab,
            },
            {
                name: fields.showTitle,
                displayName: "Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "Contextual",
                sortOrder: 12,
                tab: basicTab,
            },
            {
                name: fields.showBrandName,
                displayName: "Brand Name",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 13,
                tab: basicTab,
            },
            {
                name: fields.showPartNumbers,
                displayName: "Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 14,
                tab: basicTab,
            },
            {
                name: fields.showPrice,
                displayName: "Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 15,
                tab: basicTab,
            },
            {
                name: fields.showAddToCart,
                displayName: "Add to Cart",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 16,
                tab: basicTab,
            },
            {
                name: fields.showAddToList,
                displayName: "Add to List",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 17,
                tab: basicTab,
            },
            {
                name: fields.showImageBadges,
                displayName: "Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 18,
                tab: basicTab,
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "2",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                sortOrder: 18,
                tab: basicTab,
            },
            {
                name: fields.showTextBadges,
                displayName: "Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 19,
                tab: basicTab,
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "2",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "Contextual",
                sortOrder: 20,
                tab: basicTab,
            },
            {
                name: fields.showViewProduct,
                displayName: "View Product",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 21,
                tab: basicTab,
            },
            {
                name: fields.showQtyBox,
                displayName: "Qty box",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "Contextual",
                sortOrder: 22,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
